import axios from 'axios'
import * as utils from 'src/apis/apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/masters/staffs'), {
      params: params || {}
    })
  },
  create({ data }) {
    return axios.post(utils.getApiUrl('/masters/staffs'), data)
  },
  show(id) {
    return axios.get(utils.getApiUrl(`/masters/staffs/${id}`))
  },
  update({ id, data }) {
    return axios.put(utils.getApiUrl(`/masters/staffs/${id}`), data)
  },
  updateImprint(id, data) {
    return axios.put(utils.getApiUrl(`/masters/staffs/${id}/update_imprint`), data)
  },
}
